import { requestJson } from "../api/apiClient";

const BASE = "/api/admin/weather/alerts";

export async function fetchAdminWeatherAlertEvents({ userId, eventType, status, limit } = {}) {
  const params = new URLSearchParams();
  if (userId) params.set("userId", userId);
  if (eventType) params.set("eventType", eventType);
  if (status) params.set("status", status);
  if (limit) params.set("limit", String(limit));

  const query = params.toString();
  return requestJson(`${BASE}/events${query ? `?${query}` : ""}`);
}

export async function runAdminWeatherAlertEvaluation(body = {}) {
  return requestJson(`${BASE}/evaluate`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
